import { useState } from "react";
import { supabase } from "./supabase";

/* ─── Couleurs (reprises de theme.js pour isolation du composant) ─── */
const ACCENT = "#F59E0B";
const NAVY = "#0D1B2A";
const GRAY = "#64748B";
const RED = "#DC2626";

/* ─── Logo SVG Bati Viz (version complète avec tagline) ─── */
const LogoFull = () => (
  <svg viewBox="0 0 7195 3600" width="240" xmlns="http://www.w3.org/2000/svg" style={{ display: "block", margin: "0 auto" }}>
    <path fill="#142231" d="M1211.61,2324.56s102.57-111.68,47.86-305.42c-54.7-193.74-214.25-186.9-214.25-186.9H107.71c-48.69,0-88.16,39.47-88.16,88.16v805.94c0,58.82,47.68,106.5,106.5,106.5h944.24s218.81-34.19,232.48-280.35c0-166.39-91.17-227.93-91.17-227.93ZM176.82,2019.57c0-20.38,16.52-36.9,36.9-36.9h773.03c65.02,0,117.73,52.71,117.73,117.73v55.2c0,50.51-40.95,91.46-91.46,91.46H213.73c-20.38,0-36.9-16.52-36.9-36.9v-190.59ZM1135.65,2574.98c0,50.51-40.95,91.46-91.46,91.46H213.73c-20.38,0-36.9-16.52-36.9-36.9v-190.59c0-20.38,16.52-36.9,36.9-36.9h804.2c65.02,0,117.73,52.71,117.73,117.73v55.2Z" />
    <path fill="#142231" d="M3320.09,2832.83h50.05c29.19,0,52.85-23.66,52.85-52.85v-779.08h387.92c46.25,0,83.75-37.49,83.75-83.75h0c0-46.92-38.03-84.95-84.95-84.95h-965.36c-45.56,0-82.49,36.93-82.49,82.49h0c0,48.87,39.62,88.49,88.49,88.49h397.14s12.7,770.73,12.7,770.73c.54,32.69,27.2,58.92,59.9,58.92Z" />
    <path fill="#666c75" d="M5677.04,2179.92v593.67c0,32.72,33.09,59.25,73.92,59.25h22.03c42.68,0,77.28-27.73,77.28-61.94v-595.16c0-33.61-34-60.87-75.94-60.87h-16.12c-44.83,0-81.16,29.13-81.16,65.05Z" />
    <path fill="#142231" d="M4057.28,1922.87v827.39c0,45.6,33.09,82.57,73.92,82.57h22.03c42.68,0,77.28-38.65,77.28-86.33v-829.47c0-46.85-34-84.83-75.94-84.83h-16.12c-44.83,0-81.16,40.59-81.16,90.67Z" />
    <path fill="#142231" d="M4468.13,1995.32l501.01,759.77c53.51,81.15,172.78,80.47,225.37-1.27l577.9-898.25h-138.77c-73.79,0-142.41,37.93-181.66,100.41l-365.43,581.7-446.18-649.61c-27.58-40.15-82.35-50.62-122.79-23.47l-26.79,17.99c-37.22,24.99-47.33,75.31-22.65,112.73Z" />
    <path fill="#e47d3a" d="M5579.23,1730.85l120.58-178.09c21.66-31.98,57.76-51.14,96.39-51.14h188.01c5.83,0,9.34,6.45,6.18,11.35l-111.41,172.5c-22.89,35.45-62.21,56.86-104.41,56.86h-189.25c-5.9,0-9.4-6.6-6.09-11.48Z" />
    <path fill="#666c75" d="M6058.57,1907.66v-7.81c0-42.95,34.82-77.78,77.78-77.78h952.8c47.93,0,86.79,38.86,86.79,86.79h0c0,46.42-20.74,90.42-56.54,119.97l-763.97,630.43h743.9c42.31,0,76.61,34.3,76.61,76.61h0c0,47.95-38.87,86.83-86.82,86.83h-976.34c-37.3,0-67.54-30.24-67.54-67.54h0c0-35.45,15.55-69.12,42.53-92.11l791.32-674.21-746-6.07c-41.25-.34-74.51-33.87-74.51-75.12Z" />
    <path fill="#142231" d="M2792.75,2693.82l-565.06-822.21c-45.47-66.16-143.19-66.02-188.47.26l-581.34,851c-34.82,50.97,1.68,120.1,63.4,120.1h20.28c30.47,0,58.97-15.1,76.08-40.32l146.03-215.2,739.18,9.13,151.5,215.29c13.72,19.5,36.08,31.1,59.92,31.1,76.66,0,121.9-85.97,78.48-149.16ZM1891.43,2403.37l244.11-340.64,239.55,340.64h-483.66Z" />
    <text transform="translate(854 3559)" fill="#142231" fontFamily="Inter,sans-serif" fontSize="383" fontWeight="400" letterSpacing=".04em"><tspan x="0" y="0">Pilotez</tspan></text>
    <text transform="translate(2253 3559)" fill="#eb9c40" fontFamily="Inter,sans-serif" fontSize="465" fontWeight="300" letterSpacing=".04em"><tspan x="0" y="0">.</tspan></text>
    <text transform="translate(2525 3559)" fill="#142231" fontFamily="Inter,sans-serif" fontSize="383" fontWeight="400" letterSpacing=".04em"><tspan x="0" y="0">Analysez</tspan></text>
    <text transform="translate(4357 3559)" fill="#eb9c40" fontFamily="Inter,sans-serif" fontSize="465" fontWeight="300" letterSpacing=".04em"><tspan x="0" y="0">.</tspan></text>
    <text transform="translate(4629 3559)" fill="#142231" fontFamily="Inter,sans-serif" fontSize="383" fontWeight="400" letterSpacing=".04em"><tspan x="0" y="0">Décidez</tspan></text>
    <text transform="translate(6269 3559)" fill="#eb9c40" fontFamily="Inter,sans-serif" fontSize="465" fontWeight="300" letterSpacing=".04em"><tspan x="0" y="0">.</tspan></text>
  </svg>
);

/* ─── Styles réutilisables ─── */
const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  border: "1.5px solid #E5E9EF",
  borderRadius: 10,
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
  color: NAVY,
  fontFamily: "'Inter', sans-serif",
};

/* Bouton principal — disabled quand d=true */
const btnStyle = (disabled) => ({
  width: "100%",
  padding: "13px",
  background: disabled ? "#94A3B8" : NAVY,
  color: "#fff",
  border: "none",
  borderRadius: 10,
  fontSize: 14,
  fontWeight: 700,
  cursor: disabled ? "not-allowed" : "pointer",
  boxShadow: disabled ? "none" : "0 4px 14px rgba(13,27,42,0.35)",
  fontFamily: "'Inter', sans-serif",
});

/* Lien texte (retour, mot de passe oublié) */
const linkStyle = (color) => ({
  background: "none",
  border: "none",
  color,
  fontSize: 12,
  cursor: "pointer",
  textDecoration: "underline",
  fontFamily: "'Inter', sans-serif",
});

/**
 * Page de connexion Bati Viz
 *
 * 3 états :
 * 1. Formulaire login (email + mot de passe)
 * 2. Formulaire "mot de passe oublié" (email seul)
 * 3. Confirmation d'envoi du lien de réinitialisation
 */
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  /* ─── Connexion par email/mot de passe ─── */
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    setError(null);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
    } catch (err) {
      setError("Email ou mot de passe incorrect.");
    } finally {
      setLoading(false);
    }
  };

  /* ─── Envoi du lien de réinitialisation ─── */
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Entrez votre email d'abord.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) throw error;
      setForgotSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ─── Retour au formulaire de connexion ─── */
  const resetToLogin = () => {
    setForgotMode(false);
    setForgotSent(false);
    setError(null);
  };

  /* ─── Focus/blur pour les inputs (bordure accentuée) ─── */
  const onFocus = (e) => (e.target.style.borderColor = ACCENT);
  const onBlur = (e) => (e.target.style.borderColor = "#E5E9EF");

  return (
    <div style={{
      minHeight: "100vh",
      background: NAVY,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Inter', sans-serif",
    }}>
      {/* Fond radial décoratif */}
      <div style={{
        position: "fixed", inset: 0, zIndex: 0,
        background: "radial-gradient(ellipse at 30% 50%, rgba(228,125,58,0.1) 0%, transparent 60%)",
      }} />

      {/* Carte centrale */}
      <div style={{
        position: "relative", zIndex: 1,
        background: "#fff", borderRadius: 16,
        padding: "48px 40px", width: "100%", maxWidth: 420,
        boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
      }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <LogoFull />
        </div>

        {/* ─── État 3 : confirmation envoi email ─── */}
        {forgotSent && (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📧</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: NAVY, marginBottom: 8 }}>
              Email envoyé !
            </div>
            <div style={{ fontSize: 13, color: GRAY, lineHeight: 1.6, marginBottom: 20 }}>
              Vérifiez votre boîte mail et cliquez sur le lien pour réinitialiser votre mot de passe.
            </div>
            <button onClick={resetToLogin} style={{ ...linkStyle(ACCENT), fontSize: 13 }}>
              ← Retour à la connexion
            </button>
          </div>
        )}

        {/* ─── État 2 : formulaire mot de passe oublié ─── */}
        {!forgotSent && forgotMode && (
          <>
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: NAVY, marginBottom: 6 }}>
                Mot de passe oublié
              </div>
              <div style={{ fontSize: 13, color: GRAY }}>
                Entrez votre email — vous recevrez un lien de réinitialisation.
              </div>
            </div>

            <form onSubmit={handleForgotPassword}>
              {/* Champ email */}
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>
                  Adresse email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.fr"
                  required
                  style={inputStyle}
                  onFocus={onFocus}
                  onBlur={onBlur}
                />
              </div>

              {/* Message d'erreur */}
              {error && (
                <div style={{
                  background: "#FEF2F2", border: "1px solid #fca5a5",
                  borderRadius: 8, padding: "10px 14px",
                  fontSize: 13, color: RED, marginBottom: 16,
                }}>
                  ⚠️ {error}
                </div>
              )}

              <button type="submit" disabled={loading || !email} style={btnStyle(loading || !email)}>
                {loading ? "Envoi..." : "Envoyer le lien →"}
              </button>

              <div style={{ textAlign: "center", marginTop: 16 }}>
                <button type="button" onClick={() => { setForgotMode(false); setError(null); }} style={linkStyle(GRAY)}>
                  ← Retour à la connexion
                </button>
              </div>
            </form>
          </>
        )}

        {/* ─── État 1 : formulaire de connexion ─── */}
        {!forgotSent && !forgotMode && (
          <>
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: NAVY, marginBottom: 6 }}>
                Connexion
              </div>
              <div style={{ fontSize: 13, color: GRAY }}>
                Entrez vos identifiants pour accéder à votre dashboard.
              </div>
            </div>

            <form onSubmit={handleLogin}>
              {/* Champ email */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>
                  Adresse email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.fr"
                  required
                  style={inputStyle}
                  onFocus={onFocus}
                  onBlur={onBlur}
                />
              </div>

              {/* Champ mot de passe */}
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>
                  Mot de passe
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  style={inputStyle}
                  onFocus={onFocus}
                  onBlur={onBlur}
                />
              </div>

              {/* Message d'erreur */}
              {error && (
                <div style={{
                  background: "#FEF2F2", border: "1px solid #fca5a5",
                  borderRadius: 8, padding: "10px 14px",
                  fontSize: 13, color: RED, marginBottom: 16,
                }}>
                  ⚠️ {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading || !email || !password}
                style={btnStyle(loading || !email || !password)}
              >
                {loading ? "Connexion..." : "Se connecter →"}
              </button>

              <div style={{ textAlign: "center", marginTop: 16 }}>
                <button
                  type="button"
                  onClick={() => { setForgotMode(true); setError(null); }}
                  style={linkStyle(ACCENT)}
                >
                  Mot de passe oublié ?
                </button>
              </div>
            </form>
          </>
        )}

        {/* Footer sécurité */}
        <div style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: "#94A3B8" }}>
          🔒 Accès réservé aux utilisateurs autorisés
        </div>
      </div>
    </div>
  );
}